import { defineMessages } from 'react-intl';

export default defineMessages({
  cloneAction: {
    id: 'frontbucket.repository.source.cloneAction',
    description: 'Action to reveal options for cloning a repository',
    defaultMessage: 'Clone',
  },
});
